import { supabase } from '../lib/supabase'

// Active statuses that participate in the priority queue.
export const ACTIVE_STATUSES = ['scheduled', 'active', 'on_hold']

// Renumber sort_position 0..N-1 for the given ordered list of jobs.
// Runs updates in parallel. Returns when all updates settle.
export async function renumberJobs(orderedList) {
  if (!orderedList || orderedList.length === 0) return
  const updates = orderedList.map((j, i) => ({ id: j.id, sort_position: i }))
  await Promise.all(updates.map(u =>
    supabase.from('jobs').update({ sort_position: u.sort_position }).eq('id', u.id)
  ))
}

// Re-slot a single job into the active-priority list based on its new start_date.
// Preserves the manual ordering of other jobs — only the moved job shifts.
// Scope: same business_id as the moved job (activeBusiness filter lives in the page,
// but the auto-sort should stay consistent within a business so dates line up).
export async function reorderByDate(jobId, newStartDate, businessId) {
  if (!jobId || !newStartDate) return
  let q = supabase.from('jobs')
    .select('id, start_date, sort_position, business_id, status')
    .in('status', ACTIVE_STATUSES)
    .order('sort_position', { ascending: true, nullsFirst: false })
    .order('start_date', { ascending: true })
  if (businessId) q = q.eq('business_id', businessId)
  const { data } = await q
  if (!data) return
  const others = data.filter(j => j.id !== jobId)
  let insertAt = others.length
  for (let i = 0; i < others.length; i++) {
    const d = others[i].start_date
    if (!d) continue
    if (d > newStartDate) { insertAt = i; break }
  }
  const moved = { id: jobId, start_date: newStartDate }
  others.splice(insertAt, 0, moved)
  await renumberJobs(others)
}

// Reset all active jobs to calendar-date order (undoes manual reordering).
export async function resetOrderByDate(businessId) {
  let q = supabase.from('jobs')
    .select('id, start_date')
    .in('status', ACTIVE_STATUSES)
    .order('start_date', { ascending: true, nullsFirst: false })
  if (businessId && businessId !== 'all') q = q.eq('business_id', businessId)
  const { data } = await q
  if (!data) return
  await renumberJobs(data)
}
